// 波兰语
import constant from '../../constants/lang/pl';
import newLang from '../newLang/pl';
/* eslint-disable max-len */
export default {
  cfmoto: {
    ...(newLang.cfmoto || {}),
    constant,
    api: {
      http: {
        401: 'Proszę najpierw się zalogować',
        404: 'Brak danych',
        500: 'System jest zajęty, spróbuj ponownie później',
        504: 'Upłynął limit czasu żądania',
        ERR_NETWORK: 'Wyjątek sieci',
        ERR_NETWORK_UPLOAD: 'Przesyłanie nie powiodło się, spróbuj użyć innej sieci',
      },
    },
    title: '智能网联美国版管理后台',
    navbar: {
      dropdown: {
        updatePassword: '修改密码',
        switchLanguage: '切换语言',
        logout: '退出登录',
      },
    },
    router: {
      title: {
        'binding-agreement': '绑车协议',
        introduce: '介绍',
        lamp: 'lampka sygnalizacyjna',
        download: 'CFMOTO RIDE APP Download',
        orderConfirm: 'Order Confirmation',
        ebook: 'ebook',
        list: 'ebook',
        pdf: 'PDF',
        feedback: 'Nagrywać',
        'feedback-create': 'Informacje zwrotne',
        'feedback-supplement': 'Dodatkowe informacje zwrotne',
        'feedback-detail': 'Szczegóły opinii',
        'feedback-result': 'Informacje zwrotne',
        guide: 'Centrum pomocy',
        'guide-restScreen': 'Jak ustawić pojazd rozruchu',
        'guide-overview': 'Przegląd funkcji',
        'guide-account': 'Informacje o koncie',
        'guide-vehicle': 'Informacje o pojeździe',
        'guide-meterSetting': 'Jak skonfigurować tablicę rozdzielczą',
        'guide-vehicleSetting': 'Jak ustawić pojazd',
        'guide-findNavigation': 'Jak nawigować, aby znaleźć pojazd',
        'guide-vehicleNnavigation': 'Jak korzystać z nawigacji',
        'guide-cyclingRecord': 'Informacje o historii jazdy',
        'guide-vehicleExperience': 'Jak przeprowadzić samokontrolę pojazdu',
        'guide-useSetting': 'Jak wprowadzić ogólne ustawienia aplikacji',
        'guide-notice': 'Jak wyświetlić i ustawić powiadomienie o wiadomości',
        'guide-about': 'O aplikacji',
        help: 'Pomoc i opinie',
        'help-detail': 'Szczegóły zapytania',
        'myCar-unbinding': 'Zastosuj odblokowanie',
        'myCar-unbinding-result': 'Zastosuj odblokowanie',
      },
    },
    form: {
      cancel: 'Anuluj',
      confirm: 'Potwierdź',
      submit: 'Składać',
      search: 'Szukaj',
      language: {
        languageCode: {
          label: '请选择语言：',
          placeholder: '请选择语言',
        },
      },
    },
    rules: {
      language: {
        languageCode: {
          required: '请选择语言',
        },
      },
    },
    dialog: {
      language: '语言选择',
    },
    binding: {
      title: `Protokół `,
      text1: '1.	Usługi telematyczne',
      text2:
        'telematyczne pojazdu klientowi, który kupił pojazd CFMOTO (dalej „Klientowi” ). W ramach tych usług CFMOTO wykorzystuje dane zarejestrowane przez Pojazd na temat Pojazdu i jego zachowania podczas jazdy w odpowiednim okresie czasu. Szczegółowo dotyczy to następujących danych:',
      text3: 'Dane dotyczące zachowania użytkownika podczas jazdy : w tym przyspieszenie, opóźnienie, prędkość, zakręt, czas ostatniej jazdy i przebieg ostatniej jazdy .',
      text4:
        'Dane o stanie pojazdu: odnoszą się do stanu pojazdu w czasie rzeczywistym, w tym trybu jazdy, pozostałego paliwa, chwilowego zużycia paliwa, przebiegu, biegu pojazdu w czasie rzeczywistym, prędkości obrotowej silnika, ciśnienia w oponach, temperatury opon, danych dotyczących napięcia aktywacji akumulatora , temperatura płynu chłodzącego, stan blokady elektronicznej, wersja oprogramowania urządzenia inteligentnego, siła sygnału urządzeń inteligentnych, aktualne ustawienie deski rozdzielczej.',
      text5:
        'Dane alarmowe pojazdu: dane alarmowe do wysłania, jeśli określone dane przekroczą ustaloną wartość, takie jak temperatura silnika, nadmierna prędkość, zbyt długi czas jazdy, wysoka temperatura płynu chłodzącego, nieprawidłowy ruch pojazdu, nieprawidłowe ciśnienie w oponach, wibracje, zrzut, kolizja itp . .',
      text6: 'Informacje o usterkach pojazdu: odnoszą się do kodów usterek zgłaszanych przez każdą wewnętrzną część pojazdu.',
      text7: 'Dane o lokalizacji pojazdu: odnoszą się do określonej lokalizacji geograficznej pojazdu.',
      text8: '1.1.	Zapewnienie inż Klientowi usługi związane z pojazdami za pośrednictwem APLIKACJI CFMOTO RIDE .',
      text9: '1.1.1.	Konsumenci mogą zdalnie zarządzać pojazdami za pośrednictwem aplikacji CFMOTO RIDE APP (w tym wyświetlać lokalizację pojazdu, ustawiać informacje i funkcje pojazdu, zdalne sterowanie stanem pojazdu itp.).',
      text10: '1.1.2.	Zapewnienie planowania trasy podczas nawigacji, w tym obliczania odległości między pojazdami i nawigacji pieszej w celu znalezienia pojazdu .',
      text11: '1.2.	Wysyłanie niezbędnych powiadomień do Klienta w oparciu o stan pojazdu.',
      text12:
        '1.2.1.	CFMOTO będzie przesyłać Klientowi powiadomienia dotyczące konserwacji pojazdu (np. na podstawie całkowitej odległości przebytej przez Klienta, czasu zakupu pojazdu przez Klienta, wymaganego czasu lub odległości wymaganej do konserwacji pojazdu) .',
      text13: '1.2.2.	W oparciu o dane pojazdu , CFMOTO wyśle Klientowi powiadomienia o nietypowych sytuacjach; w tym analiza danych przez OEM (w zależności od modelu) w celu zapewnienia obsługi klienta i dalszej optymalizacji pojazdu .',
      text14: '1.3.	Wsparcie w analizie przyczyny wypadku w przypadku zgłoszenia przez Klienta poważnego wypadku Pojazdu.',
      text15:
        '1.3.1.	W przypadku poważnego wypadku Pojazdu, np. gdy Pojazd wywróci się lub przewróci na bok podczas jazdy, CFMOTO wesprze Klienta na żądanie w wyjaśnieniu, czy wypadek był spowodowany wadą Pojazdu, czy też innymi okolicznościami. Żądanie składane jest do CFMOTO przez Klienta za pośrednictwem lokalnego dystrybutora/partnera handlowego wskazanego w Umowie Sprzedaży Pojazdu.',
      text16: '1.3.2.	O ile pozwalają na to dostępne dane, CFMOTO oceni dane w odniesieniu do przyczyny wypadku i przekaże Klientowi odpowiedni raport.',
      text17: '1.4.	Pomoc Klientowi w odzyskaniu Pojazdu po utracie Pojazdu .',
      text18:
        '1.4.1.	Jeśli Pojazd zostanie zgubiony, CFMOTO dostarczy Klientowi dane dotyczące lokalizacji Pojazdu i inne przydatne dane o stanie Pojazdu (takie jak lokalizacja ostatniej aktywacji, aktualny stan pojazdu itp.) na żądanie i jeśli będą dostępne.',
      text19: '1.4.2.	Żądanie składane jest do CFMOTO przez Klienta za pośrednictwem lokalnego dystrybutora/partnera handlowego wskazanego w Umowie Sprzedaży Pojazdu.',
      text20: '1.5.	Zgłaszanie problemów posprzedażowych .',
      text21: '1.5.1.	CFMOTO zbiera zdalnie powiadomienia o kodach błędów wysyłane przez Pojazd w przypadku nieprawidłowego działania jego podzespołów i przekazuje odpowiednie informacje na żądanie Klienta bezpośrednio do Klienta.',
      text22: '1.5.2.	Żądanie składane jest do CFMOTO przez Klienta za pośrednictwem lokalnego dystrybutora/partnera handlowego wskazanego w Umowie Sprzedaży Pojazdu.',
      text23: '2.	Ograniczenia i wyłączenia usługi',
      text24: '2.1.	Wyraźnie wskazuje się, że strukturalne lub inne zmiany techniczne w Pojeździe mogą ograniczyć lub nawet uniemożliwić świadczenie usług, ponieważ świadczenie usług jest uzależnione od prawidłowego podania danych pojazdu.',
      text25: '2.2.	W przypadku, gdy takie usługi nie mogą być świadczone z powodu działania danych lub sieci telekomunikacyjnych osób trzecich , jakakolwiek odpowiedzialność CFMOTO jest wyłączona.',
      text26: '3.	Prywatność',
      text27:
        'CFMOTO będzie przestrzegać obowiązujących przepisów o ochronie danych podczas przetwarzania danych osobowych w związku z pojazdem CFMOTO . Warunki polityki prywatności C FMOTO są określone w tej aplikacji CFMOTO RIDE . Jako dodatek do polityki prywatności , t jego zawiadomienie jest zgodne z polityką prywatności . Klient może zapoznać się z polityką prywatności w przypadku niektórych treści związanych z przetwarzaniem danych, których nie obejmuje niniejsza informacja.',
      text28: '4.	Obsługa klienta',
      text29:
        '4.1.	Klient może przesyłać pytania, komentarze lub wątpliwości dotyczące prywatności na adres CFMOTORIDEAPP@cfmotousa.com lub pisać na adres: CFMOTO Powersports, Inc., 3555 Holly Lane North, Suite 30, Plymouth, M N 55447. Klient może również zadzwonić Relacje z klientami CFMOTO pod numerem (888) 823-6686. ',
      text30: '5.	rewizje _',
      text31: '5.1.	CFMOTO zastrzega sobie prawo do zmiany tego powiadomienia w dowolnym momencie, ale opublikujemy poprawki na CFMOTO RIDE Aplikacji i/lub powiadomić, zanim to zrobimy.',
    },

    atmosphere: {
      desTitle: '功能说明',
      setINfo: 'Нова подешавања ће ступити на снагу у року од 1-3 минута након што се возило укључи, уверите се да је возило у добром сигналном положају',
      setSuccess: 'Ustaw pomyślnie',
      sure: 'Pewnie',
      confirm: 'Potwierdzać',
      cancel: 'Anuluj',
      cContent: 'Подешавања још увек нису сачувана, да ли желите да их сачувате?',
      save: 'Сачувај подешавања',
      introduce1: 'Blisko instrukcji automatycznego odblokowania',
      introduce2: 'instrukcje automatycznego wyłączania',
      introduce3: 'Instrukcje automatycznego budzenia',
      introduce4: 'Opóźnione wyłączanie świateł',
      content1: {
        msg1: 'Po włączeniu funkcji telefon komórkowy włącza Bluetooth, a aplikacja nadal działa. Podchodząc do pojazdu z daleka do bliży, pojazd można automatycznie odblokować i włączyć.',
        msg2: 'Jeśli normalnie nie jest odblokowany i włączony, naciśnij przycisk zasilania pojazdu, aby odblokować i włączyć',
        msg3: 'Automatyczne odblokowanie zbliżeniowe zostanie uruchomione tylko raz przed odłączeniem Bluetooth',
      },
      content2: {
        msg1: 'Po włączeniu funkcji pojazd automatycznie wyłączy się po 5 sekundach po trzech warunkach wyłączenia pojazdu, prędkość pojazdu wynosi 0 i świątynia jest opuszczona',
        msg2: 'Uruchomienie pojazdu w okresie automatycznego wyłączania, prędkość pojazdu nie wynosi 0 lub odłożenie skroni spowoduje anulowanie automatycznego wyłączania',
      },
      content3: {
        msg1: 'Po włączeniu funkcji, gdy pojazd jest wyłączony, telefon komórkowy włącza Bluetooth, a aplikacja nadal działa lub nosi fizyczny klucz. Podczas zbliżania się do pojazdu z daleka do bliży światła pojazdu będą migać na powitanie gości',
        msg2: 'Aby zapobiec częstym wyzwalaczom powodującym utratę mocy pojazdu, po dwukrotnym uruchomieniu funkcji powitalnej w ciągu 30 sekund, zostanie ona wznowiona dopiero 30 minut później',
      },
      content4: {
        msg1: 'Po włączeniu funkcji światła drogowe i mijania zostaną włączone automatycznie na 10 sekund po wyłączeniu pojazdu',
      },
    },
    feedback: {
      label: {
        type: 'Rodzaj informacji zwrotnej (jeden wybór)',
        content: 'Opis problemu',
        fileList: 'Prosimy o przesłanie zdjęcia',
        fileList2: '(Maksymalnie 4 zdjęcia / 1 film)',
        feedbackCreate: 'Kliknij, aby otrzymać informację zwrotną',
        feedbackSupplement: 'Dodatkowe informacje zwrotne',
        backHome: 'Powrót do strony głównej',
        vehicle: 'powiązany pojazd',
        selectVehicle: 'wybierz pojazd',
      },
      placeholder: {
        'content.bug': 'Proszę opisać szczegółowo czas wystąpienia, wersję APP, model telefonu komórkowego, ścieżkę działania i opis problemu, aby pomóc szybko zlokalizować i rozwiązać problem!',
        'content.suggest': 'Zapraszamy do składania cennych sugestii, poważnie rozważymy Twoje pomysły',
        'content.vehicle': 'Proszę opisać kiedy to się stało, jak to się stało i jaki jest problem',
        'content.other': 'Proszę opisać kiedy to się stało, jak to się stało i jaki jest problem',
        'content.supplement': 'Dodaj opis problemu',
        vehicle: 'Proszę wybrać pojazd',
      },
      rules: {
        'type.required': 'Wybierz typ opinii',
        'content.required': 'Proszę wprowadzić opis problemu',
        'fileList.uploading': 'Przesyłanie, proszę czekać',
        'fileList.maxSize': 'Przesłany plik jest zbyt duży',
        'fileList.overType': 'Nieobsługiwany format',
        'fileList.maxCount': 'Liczba załadowanych plików przekracza limit',
        'fileList.acceptImageVideo': 'Podczas wybierania zdjęć nie można wybrać filmu wideo',
        'vehicle.required': 'Proszę wybrać pojazd',
      },
      message: {
        empty: 'W chwili obecnej nie ma zapisów zwrotnych.',
        finish: 'Odpowiedz',
        loading: 'Ładowanie',
        uploadFailed: 'Przesyłanie nie powiodło się',
        tip: 'Aby chronić bezpieczeństwo swojego konta, prosimy nie podawać tutaj wrażliwych danych osobowych, takich jak hasła do kont itp. ',
        feedbackSuccess: 'Otrzymana informacja zwrotna',
        'submit.error': 'Informacja zwrotna nie powiodła się',
        'submit.success': 'Otrzymana informacja zwrotna',
      },
    },
    guide: {
      label: { giveFeedback: 'Nierozwiązany, chcę wyrazić opinię' },
    },
    help: {
      label: {
        history: 'Przeszukaj rekordy',
        cancel: 'Anuluj',
        yes: 'tak',
        no: 'Não',
        unresolved: 'Nadal nie możesz rozwiązać? Kliknij',
        submitFeedback: 'Prześlij opinię',
      },
      placeholder: {
        search: 'Szukaj',
        'content.required': 'Wprowadź słowo kluczowe',
      },
      message: {
        empty: 'Brak powiązanych treści',
        empty2: 'Zaproponuj zmianę słów kluczowych lub',
        finish: 'Odpowiedz',
        historyDelete: 'Usunąć wszystkie rekordy wyszukiwania?',
        isHelpful: 'Czy to pomaga?',
      },
    },
    unbinding: {
      label: {
        vin: 'VIN',
        realName: 'Imię i nazwisko',
        email: 'Adres e-mail',
        phone: 'Numer telefonu',
        areaCode: 'Kod pocztowy',
        identity: 'Identyfikacja',
        drivingLicense: 'Dokument rejestracyjny pojazdu.',
        backHome: 'Powrót do strony głównej',
        areaCodeTitle: 'Numer kierunkowy kraju',
        latterTitle: 'Ogłoszenie',
        agree: ' Aprobata',
        disagree: 'nie zgadzać się',
        agreeCheckLabel: ' Przeczytałem i zgadzam się',
        agreeCheckTitle: 'Instrukcje dotyczące ubiegania się o wyrejestrowanie pojazdu',
      },
      placeholder: {
        vin: 'Podaj VIN',
        realName: 'Wpisz swoje prawdziwe imię',
        email: 'Podaj swój adres e-mail',
        phone: 'Wprowadź swój numer telefonu',
        identity: 'Główna strona dowodu osobistego, prawa jazdy lub paszportu, zawierająca informacje tożsamościowe.',
        drivingLicense: 'Główna strona dokumentu rejestracyjnego pojazdu z imieniem właściciela i numerem identyfikacyjnym VIN.',
      },
      rules: {
        'agree.required': 'Przeczytaj i zaakceptuj',
        'vin.required': 'Podaj VIN',
        'vin.pattern': 'Nieprawidłowy numer VIN, proszę sprawdzić.',
        'realName.required': 'Wpisz swoje prawdziwe imię',
        'email.required': 'Podaj swój adres e-mail',
        'email.pattern': 'Nieprawidłowy format adresu e-mail, proszę sprawdzić.',
        'phone.required': 'Wprowadź swój numer telefonu',
        'phone.pattern': 'Błąd formatu numeru telefonu, sprawdź',
        'fileList.maxCount': 'Liczba załadowanych plików przekracza limit',
        'fileList.uploading': 'Przesyłanie, proszę czekać',
      },
      message: {
        imgUploadFailed: 'Przesyłanie zdjęć nie powiodło się',
        securityMessage: 'Powyższe informacje są wykorzystywane tylko w celu weryfikacji tożsamości, CFMOTO chroni Twoje dane.',
        resultMessage: 'Zweryfikujemy materiały aplikacyjne tak szybko, jak to możliwe, zwróć uwagę na pasek powiadomień lub centrum wiadomości APP na czas.',
        loading: 'Ładowanie',
      },
    },
  },
};
